<template>
    <div v-if="textContentDetail.titleList.length > 0 && this.textContentDetail.detail.learningCenterId" class="learning-center-editor-content">
        <el-row align="middle">
            <el-card class="title-custom-content">
                <el-col class="text-left">
                    <span class="title-text">Title</span>
                </el-col>
                <el-col>
                    <el-input
                        v-model="textContentDetail.detail.title"
                        :disabled="textContentDetail.detail.isPublish"
                        @focus="clearDefaultTitle()"
                        @blur="setDefaultTitle()"
                        @input="updateTextContent()"
                    ></el-input>
                </el-col>
                <!-- <el-col :span="12" class="text-left">
                    <el-button v-for="item in textSizeBtnList" :key="item.id" type="text" class="text-size-custom" @click="selectParagraphFormat(item)">
                        <span :class="item.label">{{item.label}}</span>
                    </el-button>
                </el-col> -->
                <el-col :span="4" class="text-left title-status" >
                    Status :
                    <span v-if="statusSend === 'save'" style="color:green"> Saved !</span>
                    <span v-if="statusSend === 'loading'" style="color:red"> Saving ... </span>
                    <span v-if="statusSend === 'fail'" style="color:red"> Save Fail! </span>
                </el-col>
                <el-col :span="20" class="text-right">
                    <el-button icon="el-icon-delete-solid" class="delete-btn-text" size="small" @click="deleteTextContent">
                    </el-button>
                    <el-button class="duplicate-btn-text" size="small" @click="duplicateTextContent(textContentDetail.detail)">
                        <span>Duplicate</span>
                    </el-button>
                    <el-button class="publish-btn-text" size="small" :disabled="textContentDetail.detail.isPublish" @click="publishTextContent">
                        <span>Publish</span>
                    </el-button>
                    <el-button class="preview-btn-text" size="small" @click="previewTextContent">
                        <i class="material-icons">remove_red_eye</i>
                        &nbsp;
                        <span>Preview Mode</span>
                    </el-button>
                </el-col>
                <el-dialog
                    title="ยืนยันการลบ"
                    class="delete-dialog"
                    :visible.sync="dialogVisible"
                    width="30%"
                    :show-close="false"
                    :before-close="handleClose"
                >
                    <el-row>
                        <el-col class="dialog-delete-confirm-text">
                            <span>คุณต้องการลบบทความนี้หรือไม่</span>
                        </el-col>
                        <el-col class="dialog-delete-title-text">
                            <span>{{`"${textContentDetail.detail.title}"`}}</span>
                        </el-col>
                    </el-row>
                    <span slot="footer" class="dialog-footer middle delete-dialog-action">
                        <el-row>
                            <el-col :span="12" class="text-center">
                                <el-button class="cancel" type="text" @click="dialogVisible = false">ยกเลิก</el-button>
                            </el-col>
                            <el-col :span="12" class="text-center confirm-btn">
                                <el-button class="confirm" type="text" @click="confirmDeleteTextContent">ตกลง</el-button>
                            </el-col>
                        </el-row>
                    </span>
                </el-dialog>
            </el-card>
        </el-row>
        <el-row class="cms-editor-content-main">
            <el-col>
                <div :disabled="textContentDetail.detail.isPublish">
                    <ckeditor
                        v-model="textContentDetail.detail.html"
                        :editor="editor"
                        :disabled="textContentDetail.detail.isPublish"
                        :config="editorConfig"
                        @input="onEditorInput"
                    ></ckeditor>
                </div>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import firebase from 'firebase/app'
import fgApi from '@/services/fillgoods'
import learningCenter from '@/components/LearningCenter/mixins/learningCenter.js'
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor'
import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials'
import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold'
import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic'
import underlinePlugin from '@ckeditor/ckeditor5-basic-styles/src/underline'
import LinkPlugin from '@ckeditor/ckeditor5-link/src/link'
import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph'
import Image from '@ckeditor/ckeditor5-image/src/image'
import ImageToolbar from '@ckeditor/ckeditor5-image/src/imagetoolbar'
import ImageCaption from '@ckeditor/ckeditor5-image/src/imagecaption'
import ImageStyle from '@ckeditor/ckeditor5-image/src/imagestyle'
import ImageResize from '@ckeditor/ckeditor5-image/src/imageresize'
import ImageUpload from '@ckeditor/ckeditor5-image/src/imageupload'
import Autoformat from '@ckeditor/ckeditor5-autoformat/src/autoformat'
import Header from '@ckeditor/ckeditor5-heading/src/heading'
import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment'
import Indent from '@ckeditor/ckeditor5-indent/src/indent'
import IndentBlock from '@ckeditor/ckeditor5-indent/src/indentblock'
import Font from '@ckeditor/ckeditor5-font/src/font'
import list from '@ckeditor/ckeditor5-list/src/list'
// import Base64UploadAdapter from '@ckeditor/ckeditor5-upload/src/adapters/base64uploadadapter'
class UploadAdapter {
    constructor (loader) {
        this.loader = loader
    }
    upload () {
        return this.loader.file
            .then(uploadedFile => {
                return new Promise((resolve, reject) => {
                    const storageRef = firebase.apps[3].storage().ref()
                    const path = `learning_center/${new Date()}-${uploadedFile.name}`
                    const metadata = {
                        contentType: uploadedFile.type
                    }
                    storageRef.child(path).put(uploadedFile, metadata).then((snapshot) => {
                        snapshot.ref.getDownloadURL().then((downloadURL) => {
                            resolve({
                                default: downloadURL
                            })
                        })
                    }).catch((error) => {
                        reject(error)
                    })
                })
            })
    }

    abort () {}
}
export default {
    name: 'LearningCenterEditorContent',
    props: {
        textContentDetail: {
            type: Object,
            default: () => {
                return {
                    titleList: [],
                    detail: null,
                    subTitleDetail: {
                        id: '',
                        text: ''
                    }
                }
            }
        }
    },
    mixins: [learningCenter],
    data () {
        return {
            dialogVisible: false,
            documentTitle: '',
            editor: ClassicEditor,
            editorConfig: {
                plugins: [
                    EssentialsPlugin,
                    BoldPlugin,
                    ItalicPlugin,
                    LinkPlugin,
                    ParagraphPlugin,
                    Image,
                    ImageToolbar,
                    ImageCaption,
                    ImageStyle,
                    ImageResize,
                    // Base64UploadAdapter,
                    ImageUpload,
                    Autoformat,
                    Header,
                    Alignment,
                    underlinePlugin,
                    Font,
                    Indent,
                    IndentBlock,
                    list
                    // Indent
                ],
                // isReadOnly: true,
                toolbar: {
                    items: [
                        'bold', 'italic', 'underline',
                        '|',
                        'heading', 'fontColor', 'fontBackgroundColor',
                        '|',
                        'alignment:left', 'alignment:right', 'alignment:center', 'alignment:justify',
                        '|',
                        'bulletedList', 'numberedList',
                        '|',
                        'ImageUpload', 'link',
                        '|',
                        'outdent', 'indent',
                        '|',
                        'undo', 'redo'

                    ]
                },
                extraPlugins: [ this.MyCustomUploadAdapterPlugin ],
                heading: {
                    options: [
                        { model: 'heading2', view: 'h2', title: 'Subtitle', class: 'ck-heading_heading2' },
                        { model: 'heading3', view: 'h3', title: 'Header', class: 'ck-heading_heading3' },
                        { model: 'heading4', view: 'h4', title: 'Subheader', class: 'ck-heading_heading4' },
                        { model: 'paragraph', title: 'text', class: 'ck-heading_paragraph' }
                    ]
                },
                image: {
                    toolbar: [ 'imageTextAlternative', '|', 'imageStyle:alignLeft', 'imageStyle:alignCenter', 'imageStyle:alignRight' ],
                    styles: [
                        // This option is equal to a situation where no style is applied.
                        'alignCenter',

                        // This represents an image aligned to the left.
                        'alignLeft',

                        // This represents an image aligned to the right.
                        'alignRight'
                    ],
                    resizeUnit: 'px'
                },
                indentBlock: {
                    offset: 1,
                    unit: 'em'
                },
                fontColor: {
                    colors: [
                        {
                            color: '#1D8649',
                            label: '#1D8649'
                        },
                        {
                            color: '#AAC27F',
                            label: '#AAC27F'
                        },
                        {
                            color: '#B00020',
                            label: '#B00020'
                        },
                        {
                            color: '#000000',
                            label: '#000000'
                        },
                        {
                            color: '#00000099',
                            label: '#00000099'
                        },
                        {
                            color: '#0000005C',
                            label: '#0000005C'
                        }
                    ]
                },
                fontBackgroundColor: {
                    colors: [
                        {
                            color: '#AAC27F',
                            label: '#AAC27F'
                        }
                    ]
                }
            },
            timeout: null,
            statusSend: 'save'
        }
    },
    computed: {
    },
    watch: {
        'textContentDetail.subTitleDetail': {
            deep: true,
            handler (info) {
                this.autoScrollingSubTitle(info)
            }
        }
    },
    methods: {
        async duplicateTextContent (detail) {
            try {
                this.$loading()
                let param = {
                    title: detail.title,
                    html: detail.html,
                    isPublish: false
                }
                let res = await fgApi.cms.createLearningContent(param)
                if (res.success) {
                    this.textContentDetail.titleList.push({ ...res.data, subTitle: [] })
                    this.notifyLearningCenter('Duplicate complete', 'success')
                } else {
                    this.notifyLearningCenter('Duplicate fail!!', 'error')
                }
            } catch (error) {
                this.notifyLearningCenter(error, 'error')
            }
            this.$loading().close()
        },
        setDefaultTitle () {
            if (this.textContentDetail.detail.title === '') {
                this.textContentDetail.detail.title = 'Untitle'
            }
            this.updateTextContent()
        },
        clearDefaultTitle () {
            if (this.textContentDetail.detail.title === 'Untitle') {
                this.textContentDetail.detail.title = ''
            }
        },
        publishTextContent () {
            this.textContentDetail.detail.isPublish = true
            this.updateTextContent('Publish')
            // window.open(`http://localhost:3000/${this.textContentDetail.detail.title}`, '_blank')
            window.open(`https://blog-dev.fillgoods.me/${this.textContentDetail.detail.title}`, '_blank')
            // window.open(`https://blog-uat.fillgoods.me/${this.textContentDetail.detail.title}`, '_blank')
            // window.open(`https://blog-prod.fillgoods.me/${this.textContentDetail.detail.title}`, '_blank')
        },
        async updateTextContent (handler = '') {
            this.textContentDetail.titleList = await this.updateTextContentInfo(this.textContentDetail.detail, handler)
            this.statusSend = 'save'
        },
        deleteTextContent () {
            this.dialogVisible = true
        },
        handleClose () {
            this.dialogVisible = false
        },
        async confirmDeleteTextContent () {
            try {
                this.$loading()
                let res = await fgApi.cms.deleteLearningContentWithId(this.textContentDetail.detail.learningCenterId)
                if (res.success) {
                    this.textContentDetail.titleList = await this.getAllContentTitle()
                    this.notifyLearningCenter('Delete complete', 'success')
                    this.dialogVisible = false
                    this.textContentDetail.detail = {
                        learningCenterId: 0,
                        title: '',
                        html: '<p></p>',
                        isPublish: false,
                        orderRank: 0
                    }
                } else {
                    this.notifyLearningCenter('Delete fail', 'error')
                }
            } catch (error) {
                this.notifyLearningCenter(error, 'error')
            }
            this.$loading().close()
        },
        autoScrollingSubTitle (subTitle) {
            if (subTitle.id !== '') {
                let textContent = document.getElementsByClassName('ck-content')
                let end = textContent[0].getElementsByTagName('h3')[subTitle.id].offsetTop
                textContent[0].scroll(0, end - 50)
            }
        },
        async previewTextContent () {
            try {
                this.$loading()
                let param = {
                    learningCenterId: this.textContentDetail.detail.learningCenterId
                }
                let res = await fgApi.cms.previewLearningContent(param)
                if (res.success) {
                    let previewName = res.data.find(e => e.learningCenterId === this.textContentDetail.detail.learningCenterId).title
                    // window.open(`http://localhost:3000/LearningCenter/preview/${previewName}`, '_blank')
                    window.open(`https://blog-dev.fillgoods.me/LearningCenter/preview/${previewName}`, '_blank')
                    // window.open(`https://blog-uat.fillgoods.me/LearningCenter/preview/${previewName}`, '_blank')
                    // window.open(`https://blog-prod.fillgoods.me/LearningCenter/preview/${previewName}`, '_blank')
                }
            } catch (error) {
                this.notifyLearningCenter(error, 'error')
            }
            this.$loading().close()
        },
        onEditorInput (data) {
            // console.log(data)
            this.textContentDetail.detail.html = data
            this.statusSend = 'loading'
            clearTimeout(this.timeout)
            this.timeout = setTimeout(() => {
                this.updateTextContent()
            }, 500)
        },
        MyCustomUploadAdapterPlugin (editor) {
            editor.plugins.get('FileRepository').createUploadAdapter = (loader) => {
                return new UploadAdapter(loader)
            }
        }
    }
}
</script>
<style lang="scss">
.learning-center-editor-content{
    .title-custom-content{
        .title-text{
            font-size: 24px;
            font-weight: 500;
        }
        .title-status{
            font-size: 15px;
            font-weight: 500;
        }
        padding-bottom: 20px;
        .text-size-custom{
            font-family: 'Kanit' !important;
            color: #000000DE;
            .Subtitle{
                font-size: 18px;
                font-weight: bold;
            }
            .Header{
                font-size: 15px;
                font-weight: bold;
            }
            .SubHeader{
                font-size: 14px;
                font-weight: 400;
            }
            .Text{
                font-size: 14px;
                font-weight: lighter;
            }
        }
        .preview-btn-text{
            font-family: 'Kanit' !important;
            font-weight: 500;
            color: #1D8649;
            font-size: 15px;
        }
        .delete-btn-text{
            color: red;
            font-size: 15px;
        }
        .duplicate-btn-text{
            font-family: 'Kanit' !important;
            font-weight: 500;
            font-size: 15px;
        }
        .publish-btn-text{
            font-family: 'Kanit' !important;
            font-weight: 500;
            color: #FFFFFF;
            background-color: #1D8649;
            font-size: 15px;
        }
        .delete-dialog{
            .el-dialog__title{
                font-family: 'Kanit' !important;
                font-size: 22px;
                font-weight: 400;
                color: #B00020;
            }
            .el-dialog__footer{
                padding-bottom: 0;
            }
            .delete-dialog-action{
                border-top: 1px solid #0000001F;
                .el-row{
                    width: 100%;
                    padding-top: 5px;
                }
                .confirm-btn{
                    border-left: 1px solid #0000001F;
                }
                .confirm{
                    font-family: 'Kanit' !important;
                    font-size: 15px;
                    font-weight: 500;
                    color: #1D8649;
                }
                .cancel{
                    font-family: 'Kanit' !important;
                    font-size: 15px;
                    font-weight: 500;
                    color: #00000099;
                }
            }
            .middle{
                display: flex;
                justify-content: center;
            }
            .el-dialog__body{
                font-family: 'Kanit' !important;
                font-size: 16px;
                font-weight: 400;
                .dialog-delete-confirm-text{
                    color: #00000099;
                }
                .dialog-delete-title-text{
                    color: #000000DE;
                }
            }
        }
    }
    .el-row {
        .el-col{
            padding: 5px 0;
        }
    }
    .ck-content{
        h1{
            font-size: 52px;
            font-weight: 400;
            line-height: unset;
        }
        h2{
            font-size: 36px;
            font-weight: 300;
            line-height: unset;
        }
        h3{
            font-size: 36px;
            font-weight: 500;
            line-height: unset;
        }
        h4{
            font-size: 28px;
            font-weight: 400;
            line-height: unset;
        }
        p{
            font-size: 22px;
            font-weight: 300;
            line-height: unset;
        }
        li{
            font-family: 'kanit' !important;
            font-size: 22px;
            font-weight: 300;
            line-height: unset;
        }
        figure{
            padding: 57px 0px;
        }
    }
}
</style>
<style>
    .ck-editor__editable_inline {
        height: calc(88vh - 100px);
    }
</style>
